import React from "react";

// Preset palette mapped to tailwind classes.
const COLOR_MAP = {
  green: "bg-green-100 text-green-800 border-green-300",
  blue: "bg-blue-100 text-blue-800 border-blue-300",
  purple: "bg-purple-100 text-purple-800 border-purple-300",
  amber: "bg-amber-100 text-amber-800 border-amber-300",
  red: "bg-red-100 text-red-800 border-red-300",
  gray: "bg-gray-200 text-gray-700 border-gray-300",
  indigo: "bg-indigo-100 text-indigo-800 border-indigo-300",
  orange: "bg-orange-100 text-orange-800 border-orange-300",
};

export const ORDER_TYPE_COLORS = Object.keys(COLOR_MAP);

/**
 * Small colored pill for an admin-defined "Order Type" value.
 * Props: name, color (one of the ORDER_TYPE_COLORS), fallback shown if empty.
 */
export default function OrderTypeBadge({ name, color, fallback = "—", testid }) {
  if (!name) return <span className="text-muted-foreground text-xs" data-testid={testid}>{fallback}</span>;
  const cls = COLOR_MAP[color] || COLOR_MAP.gray;
  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium border ${cls}`}
      data-testid={testid}
    >
      {name}
    </span>
  );
}
